var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquityEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 36,
    viewBox: "0 0 189 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 34.5L31.4482 9.02664L25.9939 3.57227L0.5 29.5L5.5 34.5Z",
    fill: "url(#paint0_linear_1351_109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 34.5L31.4482 9.02664L25.9939 3.57227L0.5 29.5L5.5 34.5Z",
    fill: "url(#paint1_linear_1351_109)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50713 27.3219V13.9314H0.0078125V27.3219C0.0078125 31.4638 3.36524 34.8211 7.50713 34.8211H20.8976V27.3219H7.50713ZM26.3502 0.979492H7.50713C3.36524 0.979492 0.0078125 4.33686 0.0078125 8.47875V8.48849H26.3502V34.8211C30.4921 34.8211 33.8495 31.4638 33.8495 27.3219V8.47875C33.8495 4.33686 30.4921 0.979492 26.3502 0.979492Z",
    fill: "#36D66B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9875 11.4458V15.3681H52.2543V17.8553H46.9875V22.0021H52.9276V24.5572H43.8496V8.89062H52.9276V11.4458H46.9875Z",
    fill: "#36D66B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5488 27.3125L66.1727 24.4671C65.5152 24.6304 64.8441 24.7143 64.1549 24.7143C62.6903 24.7143 61.3458 24.3697 60.1192 23.6827C58.8949 22.9957 57.9223 22.0435 57.2058 20.826C56.4894 19.6085 56.1289 18.23 56.1289 16.6905C56.1289 15.1511 56.4871 13.7953 57.2058 12.5778C57.9223 11.3603 58.8949 10.408 60.1192 9.72104C61.3435 9.03407 62.6903 8.68945 64.1549 8.68945C65.6195 8.68945 66.9822 9.03407 68.1997 9.72104C69.4172 10.408 70.3808 11.3603 71.0904 12.5778C71.8 13.7953 72.1537 15.1669 72.1537 16.6905C72.1537 18.0803 71.8589 19.3455 71.2695 20.4904C70.68 21.6331 69.8751 22.5627 68.8594 23.2814L72.4462 27.3148H68.5466L68.5488 27.3125ZM59.9651 19.4452C60.3686 20.2365 60.9332 20.8464 61.6564 21.2726C62.3819 21.6989 63.214 21.912 64.1572 21.912C65.1003 21.912 65.9279 21.6989 66.6443 21.2726C67.3608 20.8464 67.9208 20.2388 68.3243 19.4452C68.7279 18.654 68.9297 17.7357 68.9297 16.6883C68.9297 15.6408 68.7279 14.7271 68.3243 13.9426C67.9208 13.1582 67.3608 12.5574 66.6443 12.1379C65.9279 11.7207 65.0981 11.5099 64.1572 11.5099C63.2163 11.5099 62.3819 11.7185 61.6564 12.1379C60.9309 12.5551 60.3686 13.1582 59.9651 13.9426C59.5615 14.7271 59.3597 15.6431 59.3597 16.6883C59.3597 17.7335 59.5615 18.654 59.9651 19.4452Z",
    fill: "#36D66B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7518 8.91309V18.5942C78.7518 19.6553 79.0284 20.4647 79.5816 21.0247C80.1348 21.5847 80.9102 21.8658 81.9123 21.8658C82.9144 21.8658 83.7125 21.5847 84.2657 21.0247C84.8189 20.4647 85.0955 19.6553 85.0955 18.5942V8.91309H88.2561V18.5738C88.2561 19.9046 87.9681 21.0269 87.3922 21.9474C86.8163 22.8657 86.0478 23.5572 85.0842 24.0197C84.1206 24.4822 83.0482 24.7157 81.8693 24.7157C80.6903 24.7157 79.6474 24.4845 78.6974 24.0197C77.7497 23.5572 76.9969 22.8657 76.446 21.9474C75.8928 21.0292 75.6162 19.9046 75.6162 18.5738V8.91309H78.7541H78.7518Z",
    fill: "#36D66B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5402 8.91309V24.557H92.4023V8.91309H95.5402Z",
    fill: "#36D66B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.387 8.91309V11.4456H106.217V24.557H103.08V11.4456H98.9102V8.91309H110.385H110.387Z",
    fill: "#36D66B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.125 8.91309L121.836 19.1111V24.557H118.698V19.1111L113.386 8.91309H116.927L120.289 16.0617L123.629 8.91309H127.125Z",
    fill: "#36D66B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.592 11.4145V15.3369H138.859V17.824H133.592V21.9708H139.532V24.526H130.454V8.85938H139.532V11.4145H133.592Z",
    fill: "#36D66B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.305 9.84541C154.552 10.487 155.515 11.403 156.196 12.591C156.876 13.7791 157.216 15.1575 157.216 16.7265C157.216 18.2954 156.876 19.6671 156.196 20.8392C155.515 22.0114 154.552 22.9206 153.305 23.5622C152.058 24.2038 150.611 24.5258 148.968 24.5258H143.499V8.88184H148.968C150.611 8.88184 152.058 9.20378 153.305 9.84541ZM152.665 20.5128C153.563 19.6172 154.01 18.3543 154.01 16.7242C154.01 15.0941 153.561 13.8221 152.665 12.9016C151.77 11.9834 150.5 11.5232 148.856 11.5232H146.639V21.855H148.856C150.5 21.855 151.77 21.406 152.665 20.5105V20.5128Z",
    fill: "#36D66B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.577 13.5886C171.219 12.9311 170.725 12.43 170.097 12.0877C169.471 11.7431 168.739 11.573 167.902 11.573C166.975 11.573 166.154 11.7816 165.435 12.2011C164.719 12.6205 164.159 13.2168 163.755 13.9944C163.352 14.7721 163.15 15.6677 163.15 16.6834C163.15 17.6991 163.356 18.64 163.766 19.4177C164.177 20.1953 164.748 20.7916 165.481 21.2111C166.213 21.6305 167.063 21.8391 168.036 21.8391C169.231 21.8391 170.21 21.5217 170.972 20.8868C171.734 20.252 172.235 19.3655 172.473 18.2296H167.095V15.8309H175.567V18.5652C175.357 19.6557 174.91 20.6647 174.223 21.592C173.536 22.5192 172.65 23.2606 171.568 23.8229C170.484 24.3829 169.271 24.6641 167.927 24.6641C166.417 24.6641 165.054 24.324 163.837 23.6438C162.619 22.9636 161.663 22.0182 160.969 20.8098C160.273 19.599 159.926 18.2251 159.926 16.6856C159.926 15.1462 160.273 13.7677 160.969 12.5502C161.663 11.3327 162.619 10.3827 163.837 9.70483C165.054 9.02466 166.41 8.68457 167.904 8.68457C169.666 8.68457 171.199 9.11308 172.498 9.97237C173.797 10.8316 174.695 12.0378 175.187 13.5909H171.579L171.577 13.5886Z",
    fill: "#36D66B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.151 11.4145V15.3369H187.418V17.824H182.151V21.9708H188.092V24.526H179.014V8.85938H188.092V11.4145H182.151Z",
    fill: "#36D66B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_109",
    x1: 1.69238,
    y1: 31.5093,
    x2: 29.7549,
    y2: 7.07702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D6DAD7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#616F64",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B3021",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071E0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_109",
    x1: 1.69292,
    y1: 31.5123,
    x2: 29.7506,
    y2: 7.08001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#071E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#134E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#26994C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2DB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32C763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#35D269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D66B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquityEdge);
export default __webpack_public_path__ + "static/media/equityEdge.eeed277e722a9c7f7ae7b217d57f7933.svg";
export { ForwardRef as ReactComponent };